//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { filterObj } from '@/utils/util';
import { JeecgListMixin } from '@/mixins/JeecgListMixin';
import DictModal from "./modules/DictModal";
import DictItemList from "./DictItemList";
export default {
  name: "DictList",
  mixins: [JeecgListMixin],
  components: {
    DictModal: DictModal,
    DictItemList: DictItemList
  },
  data: function data() {
    return {
      description: '这是数据字典页面',
      visible: false,
      // 查询条件
      queryParam: {
        dictCode: "",
        dictName: ""
      },
      // 表头
      columns: [{
        title: '#',
        dataIndex: '',
        key: 'rowIndex',
        width: 120,
        align: "center",
        customRender: function customRender(t, r, index) {
          return parseInt(index) + 1;
        }
      }, {
        title: '字典名称',
        align: "center",
        dataIndex: 'dictName'
      }, {
        title: '字典编号',
        align: "center",
        dataIndex: 'dictCode'
      }, {
        title: '描述',
        align: "center",
        dataIndex: 'description'
      }, {
        title: '操作',
        dataIndex: 'action',
        align: "center",
        scopedSlots: {
          customRender: 'action'
        }
      }],
      dict: "",
      labelCol: {
        xs: {
          span: 8
        },
        sm: {
          span: 5
        }
      },
      wrapperCol: {
        xs: {
          span: 16
        },
        sm: {
          span: 19
        }
      },
      url: {
        list: "/sys/dict/list",
        delete: "/sys/dict/delete",
        exportXlsUrl: "sys/dict/exportXls",
        importExcelUrl: "sys/dict/importExcel"
      }
    };
  },
  created: function created() {
    this.isorter = {
      column: 'createTime',
      order: 'desc'
    };
  },
  computed: {
    importExcelUrl: function importExcelUrl() {
      return "".concat(window._CONFIG['domianURL'], "/").concat(this.url.importExcelUrl);
    }
  },
  methods: {
    getQueryParams: function getQueryParams() {
      var param = Object.assign({}, this.queryParam, this.isorter);
      param.field = this.getQueryField();
      param.pageNo = this.ipagination.current;
      param.pageSize = this.ipagination.pageSize;
      return filterObj(param);
    },
    //取消选择
    cancelDict: function cancelDict() {
      this.dict = "";
      this.visible = false;
      this.loadData();
    },
    //编辑字典数据
    editDictItem: function editDictItem(record) {
      this.$refs.dictItemList.edit(record);
    },
    // 重置字典类型搜索框的内容
    searchReset: function searchReset() {
      var that = this;
      that.queryParam.dictName = "";
      that.queryParam.dictCode = "";
      that.loadData(1);
    }
  },
  watch: {
    openKeys: function openKeys(val) {
      console.log('openKeys', val);
    }
  }
};